<template>
  <div class="fa-blankslate  pt-5">
    <div class="row">
      <div class="col-sm-12">
        <img  alt="banner" src="../../../../../assets/images/svg/failed-fa.svg"  class="img-responsive"  style="padding-bottom:26px;">
      </div>
      <div class="col-sm-12 c1" style="padding-left: 15%;padding-right: 15%;font-size: 20px;">
        Maaf
      </div>
      <div class="col-sm-12 c2 pt-1 failed-page" style="padding-top:16px !important;font-size: 16px;">
        Nomor Handphone yang digunakan sudah terdaftar dan sudah menerima request untuk pencarian agent. Jika ingin mengetahui proses lebih lanjut dari request, anda dapat menginstall applikasi Sequis apps di smartphone anda.
      </div>
       <div class="col-sm-12 c2 pt-1">
        <img v-if="isMobileAndroid()" alt="banner" src="../../../../../assets/images/svg/google-play.svg"  class="img-responsive">
        <img v-if="isMobileIphone()" alt="banner" src="../../../../../assets/images/svg/app-store.svg"  class="img-responsive">
        <template v-if="!isMobileIphone() && !isMobileAndroid()" >
          <img alt="banner" src="../../../../../assets/images/svg/google-play.svg"  class="img-responsive"  style="padding-top:50px;">
          <img alt="banner" src="../../../../../assets/images/svg/app-store.svg"  class="img-responsive"  style="padding-top:50px;">
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FailedSlate',
  methods: {
    isMobileAndroid() {
      if(/Android/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    isMobileIphone() {
      if(/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  }
};
</script>